<template>
  <div class="p-3 form-container">
    <!--        <nk-dropdown class="mb-3" :data="types" :options="{multiSelection:false}" v-model="selectedType"></nk-dropdown>-->
    <select class="mb-3 p-1 w-100 m-dropdown-input selected-items" v-on:change="handleSelectedOption">
      <option class="item " v-for="item in types" :value="item.id">{{ item.name }}</option>
    </select>
    <div>
      <label v-if="selectedType.id === 'between'">از تاریخ :</label>
      <nk-date class="mb-1" :options="{ pickerEnabled: true, pickerCss: 'btn btn-default', }" v-model="filterText" :tabindex="100" />
    </div>
    <div v-if="selectedType.id === 'between'">
      <label>تا تاریخ :</label>
      <nk-date :options="{ pickerEnabled: true, pickerCss: 'btn btn-default', }" v-model="filterText2" @update:modelValue="params.filterChangedCallback()" :tabindex="102" />
    </div>

  </div>
</template>
<script>
  import _ from "lodash"
  import jMoment from 'jalali-moment'
  export default {
    props: {
      options: { type: Object }
    },
    data: function () {
      const types = [
        { id: 'greaterThan', func: 'isAfter', name: 'بزرگتر از' },
        { id: 'lessThan', func: 'isBefore', name: 'کوچکتر از' },
        { id: 'equals', func: 'isSame', name: 'برابر با' },
        { id: 'between', func: 'between', name: 'بین' },
      ]
      return {
        filterText: null,
        filterText2: null,
        selectedType: types[0],
        types: types
      }
    },
    mounted() {
      this.settings = _.merge(this.settings, this.options)
      this.settings.selectedType && (this.selectedType = this.settings.selectedType)
    },
    watch: {
      filterText(newFilterText, oldFilterText) {
        this.params.filterChangedCallback()
      },
    },
    methods: {
      isFilterActive() {
        return (
          this.filterText !== null &&
          this.filterText !== undefined &&
          this.filterText !== ''
        )
      },
      handleSelectedOption(event) {
        // console.log(event.target.value)
        this.selectedType = this.types.find(x => x.id == event.target.value)
        if (this.filterText) this.params.filterChangedCallback()
      },
      doesFilterPass(params) {
        const value = this.params.valueGetter(params)

        if (this.isFilterActive()) {
          if (!value) return false
          let status
          if (this.selectedType?.func === 'between') {
            status = jMoment(value, 'YYYY-M-D HH:mm:ss').isSameOrAfter(jMoment(this.filterText, 'YYYY-M-D HH:mm:ss'), 'day') &&
              jMoment(value, 'YYYY-M-D HH:mm:ss').isSameOrBefore(jMoment(this.filterText2, 'YYYY-M-D HH:mm:ss'), 'day')
          } else
            status = jMoment(value, 'YYYY-M-D HH:mm:ss')[this.selectedType?.func](jMoment(this.filterText, 'YYYY-M-D HH:mm:ss'), 'day')

          return status
          // return Number(value) > Number(this.filterText);
        }
      },

      isNumeric(n) {
        return !isNaN(parseFloat(n)) && isFinite(n)
      },

      getModel() {
        return this.filterText
        // return this.isFilterActive() ? Number(this.filterText) : null;
      },

      setModel(model) {
        this.filterText = model
      },

      myMethodForTakingValueFromFloatingFilter(value) {
        this.filterText = value
        if (!value) this.filterText2 = null
      },
    },
  }
</script>
